import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT;

// Deliberately kept out of `services` in @/services: joining that array would reinstate the 401
// interceptor recursion and record refresh credentials into rrweb chunks.
export const refreshApi = axios.create({
  baseURL: `${API_BASE_URL}/auth`,
});
